<template>
  <footer class="footer">
    <div class="footer__body">
      <div class="footer__logo">
        <router-link to="/">
          <Logo />
        </router-link>
        <div class="footer__copyright">ROBUXPIER ©2018-{{ currentYear }}</div>
      </div>
      <div class="footer__nav info">
        <h3>{{ $t('navigation.title') }}</h3>
        <div class="footer__links">
          <router-link class="link" to="/">{{ $t('navigation.home') }}</router-link>
          <router-link class="link" to="/transfer">{{ $t('navigation.buyRobux') }}</router-link>
          <router-link class="link" to="/history">{{ $t('navigation.account') }}</router-link>
        </div>
      </div>
      <div class="footer__nav">
        <h3>{{ $t('navigation.info') }}</h3>
        <div class="footer__links">
          <router-link class="link" to="/privacy">{{ $t('footer.privacy') }}</router-link>
          <router-link class="link" to="/termsofuse">{{ $t('footer.terms') }}</router-link>
          <router-link class="link" to="/contacts">{{ $t('footer.contacts') }}</router-link>
        </div>
      </div>
      <div class="footer__address">
        Общество с ограниченной ответственностью ООО "ОАзиз-М" 301711-3301-ООО Кыргызская Республика, Бишкек,
        Первомайский район, бул.Молодой Гвардии, 97
        <!--        <picture>
          <source srcset="../../assets/images/footer/address-foreign-mobile.svg" media="(max-width: 1380px)" />
          <img src="../../assets/images/footer/address-foreign.svg" alt="MDN" />
        </picture>-->

        <!--        <picture>-->
        <!--          <source srcset="../../assets/images/footer/address-foreign-mobile-2.svg" media="(max-width: 743px)" />-->
        <!--          <source srcset="../../assets/images/footer/address-foreign-tablet-sm-2.svg" media="(max-width: 1132px)" />-->
        <!--          <source srcset="../../assets/images/footer/address-foreign-tablet-2.svg" media="(max-width: 1919px)" />-->
        <!--          <img src="../../assets/images/footer/address-foreign-2.svg" alt="MDN" />-->
        <!--        </picture>-->
      </div>
      <div class="footer__social">
        <div class="footer__social-links">
          <a :href="vkUrl" target="_blank" class="nav-socials__block" v-if="$store.getters.language === 'ru'">
            <img :src="require('@/assets/images/help/vk.svg')" alt="" />
          </a>
          <a :href="tgUrl" target="_blank" class="nav-socials__block">
            <img :src="require('@/assets/images/help/telegram.svg')" alt="" />
          </a>
          <a :href="youtubeUrl" target="_blank" class="nav-socials__block">
            <img :src="require('@/assets/images/help/youtube.svg')" alt="" />
          </a>
        </div>
        <div class="footer__partnership">
          <p>{{ $t('partnership.info') }}</p>
          <Button size="md" @click="isShowPartnershipModal = true">{{ $t('partnership.title') }}</Button>
        </div>

        <div class="footer__copyright">ROBUXPIER ©2018-2025</div>
      </div>
    </div>
    <PartnershipModal v-if="isShowPartnershipModal" @close="isShowPartnershipModal = false" />
  </footer>
</template>

<script>
import ipUtil from './../../utils/ip'
import Logo from '@/components/Logo/Logo.vue'
import PartnershipModal from '@/components/Modals/Partnership/PartnershipModal.vue'
import Button from '@/components/Base/Button/Button.vue'
import social from '@/mixins/social'

export default {
  name: 'Footer',
  mixins: [social],
  components: {
    Button,
    Logo,
    PartnershipModal
  },
  data() {
    return {
      isShowPartnershipModal: false
    }
  },
  methods: {
    isCountryFromRu(c) {
      return ipUtil.isCountryInRuRegion(c)
    },
    isCountryRu(c) {
      return ipUtil.isCountryRu(c)
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss">
@import './footer';
</style>
